import { render, staticRenderFns } from "./VehicleInfo.vue?vue&type=template&id=611e49a0&"
import script from "./VehicleInfo.vue?vue&type=script&lang=js&"
export * from "./VehicleInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports